import EmptyList from '@/components/EmptyList';
import Filters, { orderByFilterEnum } from '@/components/Filter';
import Loader from '@/components/Loader';
import Tab from '@/components/Tab';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import './style.scss';

const BuzzQuizz: FC = () => {
    const { strings, identity, loading, tests } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        identity: state.identity.data,
        loading: false,
        tests: [],
    }));

    const [searchName, setSearchName] = useState('');
    const [initialLoading, setInitialLoading] = useState(true);
    const [initialData, setInitialData] = useState(false);
    const [active, setActive] = useState(Constants.buzzTestStatus.PUBLISHED);

    // filters
    const [slideRange, setSlideRange] = useState<number[]>([0, 90]);
    const [fakeSlideRange, setFakeSlideRange] = useState<number[]>([0, 90]);
    const [orderBy, setOrderBy] = useState(orderByFilterEnum.ALPHABETICAL);
    const [mediaType, setMediaType] = useState({ VIDEO: false, AUDIO: false, HTML: false, EXTERNAL: false });
    const [language, setLanguage] = useState({ pt: false, en: false, '': false });
    const [visibility, setVisibility] = useState({ public: false, private: false });

    const history = useHistory();
    const dispatch = useDispatch();
    const match = useRouteMatch();

    useEffect(() => {
        if (!loading) setInitialLoading(false);
        if (tests && tests.length > 0) setInitialData(true);
    }, [loading, tests]);

    useEffect(() => {
        const {
            user: { orgId, applicationId },
        } = identity;

        let visibilityParam = undefined;

        if (visibility.private && !visibility.public) visibilityParam = '0';
        if (!visibility.private && visibility.public) visibilityParam = '1';

        let locale: string | undefined = '';

        if (!language.pt && !language.en) locale = undefined;
        else if (language.pt && language.en) locale = undefined;
        else locale = language.pt ? Constants.language.PT : Constants.language.EN;

        //TO-DO chamada endpoint pra retornar testes
    }, [active, dispatch, identity, searchName, slideRange, visibility.private, visibility.public, orderBy, language]);

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchName(e.target.value);
    };

    const handleNewTest = (): void => {
        history.push(`${match.url}/`);
    };

    const renderEmpty = () => !loading && tests && tests.length <= 0;

    return (
        <>
            {initialLoading && <Loader />}
            {!initialLoading && (
                <div className="buzz-quizzes">
                    <div className="buzz-quiz">
                        <div className="d-flex top-content">
                            <button className="btn btn-primary btn-sm new-quiz-button" onClick={handleNewTest} type="button">
                                {strings.CREATE_NEW_TEST}
                            </button>
                            <div className="form-group inner-addon left-addon">
                                <i className="material-icons-outlined align-middle input-icon">{Constants.icons.SEARCH}</i>
                                <input className="form-control" onChange={handleSearch} placeholder={strings.SEARCH} type="search" />
                            </div>
                        </div>

                        <Filters
                            entityType={Constants.entityTypes.BUZZTEST}
                            fakeSlideRange={fakeSlideRange}
                            language={language}
                            mediaType={mediaType}
                            orderBy={orderBy}
                            setFakeSlideRange={setFakeSlideRange}
                            setLanguage={setLanguage}
                            setMediaType={setMediaType}
                            setOrderBy={setOrderBy}
                            setSlideRange={setSlideRange}
                            setVisibility={setVisibility}
                            slideRange={slideRange}
                            status={active}
                            visibility={visibility}
                        />

                        <div className="tabs-container">
                            <Tab
                                active={active === Constants.buzzTestStatus.PUBLISHED}
                                icon={Constants.icons.OUTLINED_FLAG}
                                setActive={() => setActive(Constants.buzzTestStatus.PUBLISHED)}
                                title={strings.PUBLISHED}
                            />
                            <Tab
                                active={active === Constants.buzzTestStatus.DRAFT}
                                icon={Constants.icons.GESTURE}
                                setActive={() => setActive(Constants.buzzTestStatus.DRAFT)}
                                title={strings.DRAFT}
                            />
                            <Tab
                                active={active === Constants.buzzTestStatus.ARCHIVED}
                                icon={Constants.icons.HOW_TO_VOTE}
                                setActive={() => setActive(Constants.buzzTestStatus.ARCHIVED)}
                                title={strings.ARCHIVED}
                            />
                        </div>
                        <div className="quiz-container">
                            {loading ? (
                                <Loader />
                            ) : (
                                tests &&
                                (tests.length > 0 || searchName !== '' || initialData) && <div className="quiz-cards">{/* Tests cards */}</div>
                            )}
                            {renderEmpty() && (
                                <EmptyList
                                    buttonTitle={strings.CREATE_NEW_TEST}
                                    handleNewList={handleNewTest}
                                    icon={Constants.icons.BALLOT}
                                    title={strings.EMPTY_TEST_LIST}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default BuzzQuizz;
